export class EventObserver {
  constructor () {
    this.observers = {}
    this.debounceTimer = {}
    this.throttleLast = {}
    this.onceTimer = {}
    this.throttleTimer = {}
  }

  on (events, callback) {
    var eventList = events.split(',')
    for (var i = 0; i < eventList.length; i++) {
      var event = eventList[i].trim()

      if (!this.observers[event]) {
        this.observers[event] = []
      }
      this.observers[event].push(callback)
    }
  }

  off (event, callback) {
    if (event === undefined) {
      for (const event in this.observers) {
        this.off(event)
      }
      return
    }

    if (!this.observers[event]) {
      return
    }
    if (!callback) {
      this.observers[event] = []
      return
    }
    this.observers[event] = this.observers[event].filter(func => func !== callback)
  }

  trigger (evtName, ...args) {
    if (this.observers[evtName] !== undefined) {
      this.observers[evtName].forEach(function (callback) {
        callback.apply(window, args)
      })
    }
  }

  // Dispara evento somente uma vez depois de uma sequencia de eventos
  debounce (milisecs, evtName, ...args) {
    clearTimeout(this.debounceTimer[evtName])
    this.debounceTimer[evtName] = setTimeout(() => {
      this.trigger(evtName, args)
    }, milisecs)
  }

  // Dispara evento a cada intervalo de tempo
  throttle (threshold, evtName, ...args) {
    const now = new Date()
    if (!this.throttleLast[evtName]) {
      this.throttleLast[evtName] = new Date()
    }

    if (this.throttleLast[evtName] && now.getTime() < this.throttleLast[evtName].getTime() + threshold) {
      clearTimeout(this.throttleTimer[evtName])
      this.throttleTimer[evtName] = setTimeout(() => {
        this.throttleLast[evtName] = now
        this.trigger(evtName, args)
      }, threshold)
    } else {
      this.throttleLast[evtName] = now
      this.trigger(evtName, args)
    }
  }

  // Dispara evento somente uma vez no início de uma sequencia de eventos
  once (milisecs, evtName, ...args) {
    const now = new Date()
    if (this.onceTimer[evtName] === undefined || now.getTime() > this.onceTimer[evtName]) {
      this.trigger(evtName, args)
    }
    this.onceTimer[evtName] = now.getTime() + milisecs
  }

  isEventRegistered (event) {
    return this.observers[event] !== undefined
  }
}
